/**
 * Pill — small neutral chip: a soft grey tint with mono text, no border.
 * Used by Inspector meta rows (e.g. SPZ token), filter facets, version markers.
 * Same shape as Badge (rounded, borderless); Badge carries a status colour,
 * Pill stays neutral and keeps the text as authored (codes, plates, VINs).
 */

interface PillProps {
  children: React.ReactNode;
  className?: string;
}

export function Pill({ children, className = '' }: PillProps) {
  return (
    <span
      className={
        'inline-flex items-center rounded-full bg-neutral-soft px-2.5 py-[3px] font-mono text-[10px] tracking-[-0.02em] text-ink-2 ' +
        className
      }
    >
      {children}
    </span>
  );
}
